//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-classes */
/* eslint-disable functional/no-this-expressions */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
// ReSharper disable InconsistentNaming



export class UserAvatarConfigurationWithoutId implements IUserAvatarConfigurationWithoutId {
    avatarType!: AvatarType;
    headMeshIndex?: number;
    hairMeshIndex?: number;
    facialHairMeshIndex?: number;
    eyeWearMeshIndex?: number;
    clothingMeshIndex?: number;
    faceColorIndex?: number;
    hairColorIndex?: number;
    eyeColorIndex?: number;
    lipColorIndex?: number;
    facialHairColorIndex?: number;
    eyeWearColorIndex?: number;
    clothingColorIndex?: number;
    eyeLashColorIndex?: number;
    eyeBrowColorIndex?: number;

    constructor(data?: IUserAvatarConfigurationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatarType = _data["AvatarType"];
            this.headMeshIndex = _data["HeadMeshIndex"];
            this.hairMeshIndex = _data["HairMeshIndex"];
            this.facialHairMeshIndex = _data["FacialHairMeshIndex"];
            this.eyeWearMeshIndex = _data["EyeWearMeshIndex"];
            this.clothingMeshIndex = _data["ClothingMeshIndex"];
            this.faceColorIndex = _data["FaceColorIndex"];
            this.hairColorIndex = _data["HairColorIndex"];
            this.eyeColorIndex = _data["EyeColorIndex"];
            this.lipColorIndex = _data["LipColorIndex"];
            this.facialHairColorIndex = _data["FacialHairColorIndex"];
            this.eyeWearColorIndex = _data["EyeWearColorIndex"];
            this.clothingColorIndex = _data["ClothingColorIndex"];
            this.eyeLashColorIndex = _data["EyeLashColorIndex"];
            this.eyeBrowColorIndex = _data["EyeBrowColorIndex"];
        }
    }

    static fromJS(data: any): UserAvatarConfigurationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvatarConfigurationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AvatarType"] = this.avatarType;
        data["HeadMeshIndex"] = this.headMeshIndex;
        data["HairMeshIndex"] = this.hairMeshIndex;
        data["FacialHairMeshIndex"] = this.facialHairMeshIndex;
        data["EyeWearMeshIndex"] = this.eyeWearMeshIndex;
        data["ClothingMeshIndex"] = this.clothingMeshIndex;
        data["FaceColorIndex"] = this.faceColorIndex;
        data["HairColorIndex"] = this.hairColorIndex;
        data["EyeColorIndex"] = this.eyeColorIndex;
        data["LipColorIndex"] = this.lipColorIndex;
        data["FacialHairColorIndex"] = this.facialHairColorIndex;
        data["EyeWearColorIndex"] = this.eyeWearColorIndex;
        data["ClothingColorIndex"] = this.clothingColorIndex;
        data["EyeLashColorIndex"] = this.eyeLashColorIndex;
        data["EyeBrowColorIndex"] = this.eyeBrowColorIndex;
        return data;
    }
}

export interface IUserAvatarConfigurationWithoutId {
    avatarType: AvatarType;
    headMeshIndex?: number;
    hairMeshIndex?: number;
    facialHairMeshIndex?: number;
    eyeWearMeshIndex?: number;
    clothingMeshIndex?: number;
    faceColorIndex?: number;
    hairColorIndex?: number;
    eyeColorIndex?: number;
    lipColorIndex?: number;
    facialHairColorIndex?: number;
    eyeWearColorIndex?: number;
    clothingColorIndex?: number;
    eyeLashColorIndex?: number;
    eyeBrowColorIndex?: number;
}

export class UserAvatarConfiguration extends UserAvatarConfigurationWithoutId implements IUserAvatarConfiguration {
    userAvatarConfigurationId!: string;
    userId!: string;

    constructor(data?: IUserAvatarConfiguration) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userAvatarConfigurationId = _data["UserAvatarConfigurationId"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): UserAvatarConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvatarConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserAvatarConfigurationId"] = this.userAvatarConfigurationId;
        data["UserId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserAvatarConfiguration extends IUserAvatarConfigurationWithoutId {
    userAvatarConfigurationId: string;
    userId: string;
}

export class UserGroupWithoutId implements IUserGroupWithoutId {
    userGroupName!: string;
    companyId!: string;
    description?: string;
    isDefaultUserGroup?: boolean;

    constructor(data?: IUserGroupWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isDefaultUserGroup = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupName = _data["UserGroupName"];
            this.companyId = _data["CompanyId"];
            this.description = _data["Description"];
            this.isDefaultUserGroup = _data["IsDefaultUserGroup"] !== undefined ? _data["IsDefaultUserGroup"] : false;
        }
    }

    static fromJS(data: any): UserGroupWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupName"] = this.userGroupName;
        data["CompanyId"] = this.companyId;
        data["Description"] = this.description;
        data["IsDefaultUserGroup"] = this.isDefaultUserGroup;
        return data;
    }
}

export interface IUserGroupWithoutId {
    userGroupName: string;
    companyId: string;
    description?: string;
    isDefaultUserGroup?: boolean;
}

export class UserGroup extends UserGroupWithoutId implements IUserGroup {
    userGroupId!: string;
    experienceCount!: number;
    userCount!: number;

    constructor(data?: IUserGroup) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userGroupId = _data["UserGroupId"];
            this.experienceCount = _data["ExperienceCount"];
            this.userCount = _data["UserCount"];
        }
    }

    static fromJS(data: any): UserGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupId"] = this.userGroupId;
        data["ExperienceCount"] = this.experienceCount;
        data["UserCount"] = this.userCount;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGroup extends IUserGroupWithoutId {
    userGroupId: string;
    experienceCount: number;
    userCount: number;
}

export class BaseUser implements IBaseUser {
    forename!: string;
    surname!: string;
    emailAddress!: string;
    username?: string;
    language!: string;
    jobTitle?: string;
    site?: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role!: UserRole;
    country!: string;

    constructor(data?: IBaseUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forename = _data["Forename"];
            this.surname = _data["Surname"];
            this.emailAddress = _data["EmailAddress"];
            this.username = _data["Username"];
            this.language = _data["Language"];
            this.jobTitle = _data["JobTitle"];
            this.site = _data["Site"];
            this.role = _data["Role"];
            this.country = _data["Country"];
        }
    }

    static fromJS(data: any): BaseUser {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Forename"] = this.forename;
        data["Surname"] = this.surname;
        data["EmailAddress"] = this.emailAddress;
        data["Username"] = this.username;
        data["Language"] = this.language;
        data["JobTitle"] = this.jobTitle;
        data["Site"] = this.site;
        data["Role"] = this.role;
        data["Country"] = this.country;
        return data;
    }
}

export interface IBaseUser {
    forename: string;
    surname: string;
    emailAddress: string;
    username?: string;
    language: string;
    jobTitle?: string;
    site?: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role: UserRole;
    country: string;
}

export class User extends BaseUser implements IUser {
    userId!: string;
    companyId!: string;
    profilePictureUrl?: string;
    lastLogin?: Date;

    constructor(data?: IUser) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["UserId"];
            this.companyId = _data["CompanyId"];
            this.profilePictureUrl = _data["ProfilePictureUrl"];
            this.lastLogin = _data["LastLogin"] ? new Date(_data["LastLogin"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["CompanyId"] = this.companyId;
        data["ProfilePictureUrl"] = this.profilePictureUrl;
        data["LastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IBaseUser {
    userId: string;
    companyId: string;
    profilePictureUrl?: string;
    lastLogin?: Date;
}

export class UserWithCompanyName extends User implements IUserWithCompanyName {
    companyName?: string;

    constructor(data?: IUserWithCompanyName) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyName = _data["CompanyName"];
        }
    }

    static fromJS(data: any): UserWithCompanyName {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithCompanyName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        super.toJSON(data);
        return data;
    }
}

export interface IUserWithCompanyName extends IUser {
    companyName?: string;
}

export class FullUserForCreate extends User implements IFullUserForCreate {
    password!: string;

    constructor(data?: IFullUserForCreate) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): FullUserForCreate {
        data = typeof data === 'object' ? data : {};
        let result = new FullUserForCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface IFullUserForCreate extends IUser {
    password: string;
}

export class FullUserForUpdate extends User implements IFullUserForUpdate {
    password?: string;

    constructor(data?: IFullUserForUpdate) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): FullUserForUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new FullUserForUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface IFullUserForUpdate extends IUser {
    password?: string;
}

export class UserWithStatus extends User implements IUserWithStatus {
    status?: UserStatus;

    constructor(data?: IUserWithStatus) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["Status"] ? UserStatus.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserWithStatus extends IUser {
    status?: UserStatus;
}

export class UserStatus implements IUserStatus {
    isOnline!: boolean;
    desktopSessions?: DesktopSession[];
    vRSession?: VRSession;

    constructor(data?: IUserStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnline = _data["IsOnline"];
            if (Array.isArray(_data["DesktopSessions"])) {
                this.desktopSessions = [] as any;
                for (let item of _data["DesktopSessions"])
                    this.desktopSessions!.push(DesktopSession.fromJS(item));
            }
            this.vRSession = _data["VRSession"] ? VRSession.fromJS(_data["VRSession"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsOnline"] = this.isOnline;
        if (Array.isArray(this.desktopSessions)) {
            data["DesktopSessions"] = [];
            for (let item of this.desktopSessions)
                data["DesktopSessions"].push(item.toJSON());
        }
        data["VRSession"] = this.vRSession ? this.vRSession.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserStatus {
    isOnline: boolean;
    desktopSessions?: DesktopSession[];
    vRSession?: VRSession;
}

export class DesktopSession implements IDesktopSession {
    wentOnlineTime?: Date;
    applicationType?: string | undefined;
    deviceName?: string | undefined;

    constructor(data?: IDesktopSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wentOnlineTime = _data["WentOnlineTime"] ? new Date(_data["WentOnlineTime"].toString()) : <any>undefined;
            this.applicationType = _data["ApplicationType"];
            this.deviceName = _data["DeviceName"];
        }
    }

    static fromJS(data: any): DesktopSession {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WentOnlineTime"] = this.wentOnlineTime ? this.wentOnlineTime.toISOString() : <any>undefined;
        data["ApplicationType"] = this.applicationType;
        data["DeviceName"] = this.deviceName;
        return data;
    }
}

export interface IDesktopSession {
    wentOnlineTime?: Date;
    applicationType?: string | undefined;
    deviceName?: string | undefined;
}

export class VRSession implements IVRSession {
    wentOnlineTime?: Date;
    tagName?: string;
    applicationType?: string;
    deviceName?: string;
    sessionId!: string;
    /** MapPath of the RoomMetadata */
    roomName?: string;
    isRoomFull?: boolean;
    gameSessionType?: SessionType;
    serverAddress?: string;
    region?: string;

    constructor(data?: IVRSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wentOnlineTime = _data["WentOnlineTime"] ? new Date(_data["WentOnlineTime"].toString()) : <any>undefined;
            this.tagName = _data["TagName"];
            this.applicationType = _data["ApplicationType"];
            this.deviceName = _data["DeviceName"];
            this.sessionId = _data["SessionId"];
            this.roomName = _data["RoomName"];
            this.isRoomFull = _data["IsRoomFull"];
            this.gameSessionType = _data["GameSessionType"];
            this.serverAddress = _data["ServerAddress"];
            this.region = _data["Region"];
        }
    }

    static fromJS(data: any): VRSession {
        data = typeof data === 'object' ? data : {};
        let result = new VRSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WentOnlineTime"] = this.wentOnlineTime ? this.wentOnlineTime.toISOString() : <any>undefined;
        data["TagName"] = this.tagName;
        data["ApplicationType"] = this.applicationType;
        data["DeviceName"] = this.deviceName;
        data["SessionId"] = this.sessionId;
        data["RoomName"] = this.roomName;
        data["IsRoomFull"] = this.isRoomFull;
        data["GameSessionType"] = this.gameSessionType;
        data["ServerAddress"] = this.serverAddress;
        data["Region"] = this.region;
        return data;
    }
}

export interface IVRSession {
    wentOnlineTime?: Date;
    tagName?: string;
    applicationType?: string;
    deviceName?: string;
    sessionId: string;
    /** MapPath of the RoomMetadata */
    roomName?: string;
    isRoomFull?: boolean;
    gameSessionType?: SessionType;
    serverAddress?: string;
    region?: string;
}

export class CreateUserRequest extends BaseUser implements ICreateUserRequest {
    invitationToken!: string;
    password?: string;

    constructor(data?: ICreateUserRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invitationToken = _data["InvitationToken"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvitationToken"] = this.invitationToken;
        data["Password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUserRequest extends IBaseUser {
    invitationToken: string;
    password?: string;
}

export class UserAccessData implements IUserAccessData {
    userId!: string;
    userGroupId?: string;
    expiresAt?: Date;

    constructor(data?: IUserAccessData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAccessData {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserAccessData {
    userId: string;
    userGroupId?: string;
    expiresAt?: Date;
}

export class UserGroupAccessData implements IUserGroupAccessData {
    userGroupId!: string;
    expiresAt?: Date;

    constructor(data?: IUserGroupAccessData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserGroupAccessData {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupAccessData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserGroupAccessData {
    userGroupId: string;
    expiresAt?: Date;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    userIdentifier!: string;
    isV2?: boolean;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isV2 = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["UserIdentifier"];
            this.isV2 = _data["IsV2"] !== undefined ? _data["IsV2"] : false;
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserIdentifier"] = this.userIdentifier;
        data["IsV2"] = this.isV2;
        return data;
    }
}

export interface IResetPasswordRequest {
    userIdentifier: string;
    isV2?: boolean;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    userIdentifier!: string;
    password!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["UserIdentifier"];
            this.password = _data["Password"];
            this.newPassword = _data["NewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserIdentifier"] = this.userIdentifier;
        data["Password"] = this.password;
        data["NewPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    userIdentifier: string;
    password: string;
    newPassword: string;
}

export class Relationship implements IRelationship {
    user1Id!: string;
    user2Id!: string;

    constructor(data?: IRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user1Id = _data["User1Id"];
            this.user2Id = _data["User2Id"];
        }
    }

    static fromJS(data: any): Relationship {
        data = typeof data === 'object' ? data : {};
        let result = new Relationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User1Id"] = this.user1Id;
        data["User2Id"] = this.user2Id;
        return data;
    }
}

export interface IRelationship {
    user1Id: string;
    user2Id: string;
}

export class Login implements ILogin {
    userIdentifier!: string;
    password!: string;
    source?: SessionSource;
    clientId?: string;
    machineId?: number;

    constructor(data?: ILogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["UserIdentifier"];
            this.password = _data["Password"];
            this.source = _data["Source"];
            this.clientId = _data["ClientId"];
            this.machineId = _data["MachineId"];
        }
    }

    static fromJS(data: any): Login {
        data = typeof data === 'object' ? data : {};
        let result = new Login();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserIdentifier"] = this.userIdentifier;
        data["Password"] = this.password;
        data["Source"] = this.source;
        data["ClientId"] = this.clientId;
        data["MachineId"] = this.machineId;
        return data;
    }
}

export interface ILogin {
    userIdentifier: string;
    password: string;
    source?: SessionSource;
    clientId?: string;
    machineId?: number;
}

export class ExchangeToken implements IExchangeToken {
    sessionSource!: SessionSource;

    constructor(data?: IExchangeToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionSource = _data["SessionSource"];
        }
    }

    static fromJS(data: any): ExchangeToken {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionSource"] = this.sessionSource;
        return data;
    }
}

export interface IExchangeToken {
    sessionSource: SessionSource;
}

export class LoginResult implements ILoginResult {
    token!: string;
    refreshToken!: string;

    constructor(data?: ILoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.refreshToken = _data["RefreshToken"];
        }
    }

    static fromJS(data: any): LoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["RefreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ILoginResult {
    token: string;
    refreshToken: string;
}

export class InvitationWithoutId implements IInvitationWithoutId {
    isV2?: boolean;
    inviteeEmail!: string;

    constructor(data?: IInvitationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isV2 = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isV2 = _data["IsV2"] !== undefined ? _data["IsV2"] : false;
            this.inviteeEmail = _data["InviteeEmail"];
        }
    }

    static fromJS(data: any): InvitationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsV2"] = this.isV2;
        data["InviteeEmail"] = this.inviteeEmail;
        return data;
    }
}

export interface IInvitationWithoutId {
    isV2?: boolean;
    inviteeEmail: string;
}

export class InvitationSummary implements IInvitationSummary {
    createdAt?: Date;
    expiration?: Date;
    inviteeEmail?: string;

    constructor(data?: IInvitationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.expiration = _data["Expiration"] ? new Date(_data["Expiration"].toString()) : <any>undefined;
            this.inviteeEmail = _data["InviteeEmail"];
        }
    }

    static fromJS(data: any): InvitationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["InviteeEmail"] = this.inviteeEmail;
        return data;
    }
}

export interface IInvitationSummary {
    createdAt?: Date;
    expiration?: Date;
    inviteeEmail?: string;
}

export class ContactRequest extends User implements IContactRequest {
    invitationSentTime?: Date;

    constructor(data?: IContactRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invitationSentTime = _data["InvitationSentTime"] ? new Date(_data["InvitationSentTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvitationSentTime"] = this.invitationSentTime ? this.invitationSentTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IContactRequest extends IUser {
    invitationSentTime?: Date;
}

export class Permission implements IPermission {
    canRecordPrivateReplay?: boolean;
    canRecordInternalReplay?: boolean;
    canRecordPublicReplay?: boolean;
    storageSizeLimitMiB?: number;
    canUseSpectatorMode?: boolean;
    canApproveReplays?: boolean;
    displayPartnerCompanies?: boolean;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canRecordPrivateReplay = _data["CanRecordPrivateReplay"];
            this.canRecordInternalReplay = _data["CanRecordInternalReplay"];
            this.canRecordPublicReplay = _data["CanRecordPublicReplay"];
            this.storageSizeLimitMiB = _data["StorageSizeLimitMiB"];
            this.canUseSpectatorMode = _data["CanUseSpectatorMode"];
            this.canApproveReplays = _data["CanApproveReplays"];
            this.displayPartnerCompanies = _data["DisplayPartnerCompanies"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanRecordPrivateReplay"] = this.canRecordPrivateReplay;
        data["CanRecordInternalReplay"] = this.canRecordInternalReplay;
        data["CanRecordPublicReplay"] = this.canRecordPublicReplay;
        data["StorageSizeLimitMiB"] = this.storageSizeLimitMiB;
        data["CanUseSpectatorMode"] = this.canUseSpectatorMode;
        data["CanApproveReplays"] = this.canApproveReplays;
        data["DisplayPartnerCompanies"] = this.displayPartnerCompanies;
        return data;
    }
}

export interface IPermission {
    canRecordPrivateReplay?: boolean;
    canRecordInternalReplay?: boolean;
    canRecordPublicReplay?: boolean;
    storageSizeLimitMiB?: number;
    canUseSpectatorMode?: boolean;
    canApproveReplays?: boolean;
    displayPartnerCompanies?: boolean;
}

export class CreateBatchUserRequest implements ICreateBatchUserRequest {
    quantity!: number;
    userNamePrefix!: string;
    password!: string;
    emailDomain!: string;
    emailNamePrefix!: string;
    forename!: string;
    surname!: string;
    jobTitle?: string;
    country!: string;
    language!: string;
    companyId!: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role!: UserRole;

    constructor(data?: ICreateBatchUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["Quantity"];
            this.userNamePrefix = _data["UserNamePrefix"];
            this.password = _data["Password"];
            this.emailDomain = _data["EmailDomain"];
            this.emailNamePrefix = _data["EmailNamePrefix"];
            this.forename = _data["Forename"];
            this.surname = _data["Surname"];
            this.jobTitle = _data["JobTitle"];
            this.country = _data["Country"];
            this.language = _data["Language"];
            this.companyId = _data["CompanyId"];
            this.role = _data["Role"];
        }
    }

    static fromJS(data: any): CreateBatchUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quantity"] = this.quantity;
        data["UserNamePrefix"] = this.userNamePrefix;
        data["Password"] = this.password;
        data["EmailDomain"] = this.emailDomain;
        data["EmailNamePrefix"] = this.emailNamePrefix;
        data["Forename"] = this.forename;
        data["Surname"] = this.surname;
        data["JobTitle"] = this.jobTitle;
        data["Country"] = this.country;
        data["Language"] = this.language;
        data["CompanyId"] = this.companyId;
        data["Role"] = this.role;
        return data;
    }
}

export interface ICreateBatchUserRequest {
    quantity: number;
    userNamePrefix: string;
    password: string;
    emailDomain: string;
    emailNamePrefix: string;
    forename: string;
    surname: string;
    jobTitle?: string;
    country: string;
    language: string;
    companyId: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role: UserRole;
}

export class ReleaseChannel implements IReleaseChannel {
    releaseChannelId!: string;
    requirements!: ReleaseChannelRequirements;
    userGroupId?: string;
    expiresAt?: Date;

    constructor(data?: IReleaseChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseChannelId = _data["ReleaseChannelId"];
            this.requirements = _data["Requirements"];
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReleaseChannel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReleaseChannelId"] = this.releaseChannelId;
        data["Requirements"] = this.requirements;
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReleaseChannel {
    releaseChannelId: string;
    requirements: ReleaseChannelRequirements;
    userGroupId?: string;
    expiresAt?: Date;
}

export enum ReleaseChannelRequirements {
    Optional = "Optional",
    AutoQueue = "AutoQueue",
    Required = "Required",
}

export enum AvatarType {
    Stylized = "Stylized",
    Realistic = "Realistic",
}

export enum SessionSource {
    Launcher = "Launcher",
    VirtualReality = "VirtualReality",
    MobileAndroid = "MobileAndroid",
    MobileIos = "MobileIos",
    HoloLens = "HoloLens",
    OculusQuest = "OculusQuest",
    WebFrontend = "WebFrontend",
    DesktopApp = "DesktopApp",
}

/** All users are now created as User. Roles are defined via separate constructs. */
export enum UserRole {
    User = "User",
    CompanyAdministrator = "CompanyAdministrator",
    Administrator = "Administrator",
}

export enum SessionType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export class PasswordValidationResult implements IPasswordValidationResult {
    email!: boolean;
    invalidSymbolChar!: boolean;
    jobTitle!: boolean;
    length!: boolean;
    lowercaseChar!: boolean;
    name!: boolean;
    numberChar!: boolean;
    symbolChar!: boolean;
    uppercaseChar!: boolean;

    constructor(data?: IPasswordValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.invalidSymbolChar = _data["InvalidSymbolChar"];
            this.jobTitle = _data["JobTitle"];
            this.length = _data["Length"];
            this.lowercaseChar = _data["LowercaseChar"];
            this.name = _data["Name"];
            this.numberChar = _data["NumberChar"];
            this.symbolChar = _data["SymbolChar"];
            this.uppercaseChar = _data["UppercaseChar"];
        }
    }

    static fromJS(data: any): PasswordValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["InvalidSymbolChar"] = this.invalidSymbolChar;
        data["JobTitle"] = this.jobTitle;
        data["Length"] = this.length;
        data["LowercaseChar"] = this.lowercaseChar;
        data["Name"] = this.name;
        data["NumberChar"] = this.numberChar;
        data["SymbolChar"] = this.symbolChar;
        data["UppercaseChar"] = this.uppercaseChar;
        return data;
    }
}

export interface IPasswordValidationResult {
    email: boolean;
    invalidSymbolChar: boolean;
    jobTitle: boolean;
    length: boolean;
    lowercaseChar: boolean;
    name: boolean;
    numberChar: boolean;
    symbolChar: boolean;
    uppercaseChar: boolean;
}

export class UserSetting implements IUserSetting {
    settingKey!: string;
    settingValue!: string;

    constructor(data?: IUserSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["SettingKey"];
            this.settingValue = _data["SettingValue"];
        }
    }

    static fromJS(data: any): UserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SettingKey"] = this.settingKey;
        data["SettingValue"] = this.settingValue;
        return data;
    }
}

export interface IUserSetting {
    settingKey: string;
    settingValue: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}